import axios from 'axios';
import { API_ENDPOINTS } from '../../../apiConfig';
const API_BASE =  `${API_ENDPOINTS.platform}/user-role-mappings`;

export interface UserRoleMappingDTO {
    id?: string;
    userId: string;
    roleId: string;
  }
 

export const fetchUserRoleMappingByUser = (userId: string) => {
  return axios.get<UserRoleMappingDTO[]>(`${API_BASE}/user/${userId}`);
};

export const createUserRoleMapping = (dto: UserRoleMappingDTO) => {
  return axios.post<UserRoleMappingDTO>(API_BASE, dto);
};

export const deleteUserRoleMapping = (id: string) => {
  return axios.delete(`${API_BASE}/${id}`);
};

export const fetchAllUserRoleMappings = () => {
  return axios.get(API_BASE);
};

export interface UserRoleSelectionProjection {
    roleId: string;
    roleName: string;
    userId: string | null;
  }
  
  export const fetchUserRoleSelectionForUser = (userId: string) =>
    axios.get<UserRoleSelectionProjection[]>(`${API_BASE}/user/${userId}/role-selection`);
  
  export const deleteUserRoleMappingByUserAndRole = (userId: string, roleId: string) =>
    axios.delete(`${API_BASE}/user/${userId}/role/${roleId}`);

